import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, retry, delay, scan, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ISite } from './models/site.model';
import { throwError } from 'rxjs';
import { BASE_URL, END_POINTS } from 'src/app/utility/APIConstants';


@Injectable({ providedIn: 'root' })
export class MasterService {
  constructor(private _http: HttpClient) { }


// Update the method inside the class:
getSitesWithApprovedWorkOrders(clientKey: number): Observable<ISite[]> {
  return this._http.get<ISite[]>(`${environment.apiBase}/workorder/approved-sites/${clientKey}`);
}

  // users
  getAllUsers() {
    return this._http.get<any[]>(`${environment.apiBase}/user/getall`);
  }

  getUserBySite(siteKey) {
    return this._http.get<any[]>(`${environment.apiBase}/user/get-by-site?siteKey=${siteKey}`);
  }

  getAllUsersByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/user/all/bypagination`, { params });
  }

  getAllActiveUsers() {
    return this._http.get<any[]>(`${environment.apiBase}/user/getall?isTransaction=true`);
  }

  getUsersByRole(roleId) {
    return this._http.get<any[]>(`${environment.apiBase}/user/getall/role/${roleId}`);
  }

  addUser(payload, file): Observable<any> {
    const formData = new FormData();
    // Append payload properties to the FormData
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        formData.append(key, payload[key]);
      }
    }
    if (file) {
      formData.append('file', file, file.name);
    }
    return this._http.post<any>(environment.apiBase + '/user/create', formData, payload)
  }

  checkingDuplicateUserId(email, mobNo): Observable<any> {
    return this._http.get<any>(environment.apiBase + `/user/check?email=${email}&mobNo=${mobNo}`)
  }

  updateSupplier(payload, supplierKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/supplier/update/' + supplierKey, payload)
  }

  updateUser(payload, id, file): Observable<any> {
    const formData = new FormData();
    // Append payload properties to the FormData
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        formData.append(key, payload[key]);
      }
    }

    if (file) {
      formData.append('file', file, file.name);
    }
    return this._http.put<any>(environment.apiBase + '/user/update/' + id, formData)
  }

  deleteUser(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/user/' + id)
  }

  activeDeactiveUser(id, status): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/user/status/${id}?status=${status}`, {})
  }

  //   Product
  getAllProducts(params = {}) {
    return this._http.get<any>(`${environment.apiBase}/product/all/bypagination`, { params });
  }

  getAllActiveProducts() {
    return this._http.get<any[]>(`${environment.apiBase}/product/all?isTransaction=true`);
  }

  addProduct(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/product/create', payload)
  }

  updateProduct(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/product/update/' + id, payload)
  }

  importProduct(file: File): Observable<any> {
    const formData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
    }
    return this._http.post(environment.apiBase + '/product/upload', formData, {
      responseType: 'blob',
      observe: 'response'  // ✅ Get full response including headers
    });
  }


getAllClients(): Observable<any> {
  return this._http.get<any[]>(
    `${environment.apiBase}/client/all?isForTrans=true`
  );
}

// --- Labor Master APIs ---

  getAllLabors(): Observable<any[]> {
    return this._http.get<any[]>(`${environment.apiBase}/masters/labors`);
  }

  getLaborById(id: number): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/masters/labors/${id}`);
  }

  createLabor(payload: any): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/masters/labors`, payload);
  }

  updateLabor(id: number, payload: any): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/masters/labors/${id}`, payload);
  }

  deleteLabor(id: number): Observable<any> {
    return this._http.delete<any>(`${environment.apiBase}/masters/labors/${id}`);
  }


  //vendor 
  getVendorsByPageCount(arg0: { page: number; }) {
    return this._http.get<any>(environment.apiBase + '/vendor/all');
  }

  createVendor(payload: any) {
    return this._http.post<any>(environment.apiBase + '/vendor/create', payload);
  }


  updateVendor(id, payload) {
    return this._http.put<any>(environment.apiBase + '/vendor/update/' + id, payload);
  }

  // product category

  getAllProductCategorys() {
    return this._http.get<any[]>(`${environment.apiBase}/categories/all`);
  }

  getAllMakesNew() {
    return this._http.get<any[]>(
      `${environment.apiBase}/product/make/getAllMakes`
    );
  }

  getProductCategorysByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/categories/all/bypagination`, { params });
  }

  getAllActiveProductCategorys() {
    return this._http.get<any[]>(`${environment.apiBase}/categories/all?isForTrans=true`);
  }

  addProductCategory(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/categories/create', payload)
  }

  updateProductCategory(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/categories/update/' + id, payload)
  }

  deleteProductCategory(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/categories/delete/' + id).pipe(
      catchError(this.handleError)
    );
  }


// wo-type

addWoType(payload: any): Observable<any> {
  return this._http.post<any>(`${environment.apiBase}/wo-type`, payload);
}

updateWoType(id: any, payload: any): Observable<any> {
  return this._http.put<any>(`${environment.apiBase}/wo-type/${id}`, payload);
}

deleteWoType(id: any): Observable<any> {
  return this._http.delete<any>(`${environment.apiBase}/wo-type/${id}`);
}

getAllActiveWoTypes(): Observable<any> {
  // Matches @GetMapping("/active")
  return this._http.get<any>(`${environment.apiBase}/wo-type/active`);
}

getWoTypesByPageCount(params = {}): Observable<any> {
  // Matches @GetMapping("/all/bypagination")
  return this._http.get<any>(
    `${environment.apiBase}/wo-type/all/bypagination`,
    { params }
  );
}

  //-----------------

  
 // --- Billing Milestone Endpoints ---

getBillingMilestonesByPageCount(params: any): Observable<any> {
  return this._http.get(
    `${environment.apiBase}/billing-milestone/all/bypagination`,
    { params }
  );
}

addBillingMilestone(payload: any): Observable<any> {
  return this._http.post(
    `${environment.apiBase}/billing-milestone`,
    payload
  );
}

updateBillingMilestone(id: number, payload: any): Observable<any> {
  return this._http.put(
    `${environment.apiBase}/billing-milestone/${id}`,
    payload
  );
}

deleteBillingMilestone(id: number): Observable<any> {
  return this._http.delete(
    `${environment.apiBase}/billing-milestone/${id}`
  );
}

getActiveBillingMilestones(): Observable<any> {
  return this._http.get(
    `${environment.apiBase}/billing-milestone/active`
  );
}

  //---------------------------

  addNewSequenceItem(payload): Observable<any> {
    return this._http.post(environment.apiBase + '/orderSequence', payload);
  }

  updateSequenceItem(id, payload): Observable<any> {
    return this._http.put(environment.apiBase + `/orderSequence/update/${id}`, payload);
  }

  deleteSequence(id): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/orderSequence/updatestatus/' + id, {})
  }


  getSequenceData(): Observable<any> {
    return this._http.get(environment.apiBase + '/orderSequence');
  }

  getSequenceDataByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/orderSequence/all/bypagination`, { params });
  }

  addNewContractorItem(payload): Observable<any> {
    return this._http.post(environment.apiBase + '/contractor/create', payload);
  }

  updateContractorItem(id, payload): Observable<any> {
    return this._http.put(environment.apiBase + `/contractor/update/${id}`, payload);
  }

  deleteContractor(id, status): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/contractor/status/${id}?status=${status}`, {})
  }

  getAllContractor(): Observable<any> {
    return this._http.get(environment.apiBase + '/contractor/all');
  }

  getAllActiveContractor() {
    return this._http.get<any[]>(`${environment.apiBase}/contractor/all?isForTrans=true`);
  }

  getContractorByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/contractor/all/bypagination`, { params });
  }

  updateWorkOrder(id, payload): Observable<any> {
    return this._http.put(environment.apiBase + `/workorder/update/${id}`, payload);
  }

  getSiteData(): Observable<any> {
    return this._http.get<ISite[]>(environment.apiBase + '/sitescontroller/getall');
  }

  getSiteByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/sitescontroller/all/bypagination`, { params });
  }

  getSiteDataByUser(): Observable<any> {
    return this._http.get<ISite[]>(environment.apiBase + '/sitescontroller/get-all-by--user');
  }

  getSiteDataByUserByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/sitescontroller/get-all-by--user/`, { params });
  }

  getSiteCountByUser(): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/sitescontroller/count-by-user`);
  }

  getAllActiveSiteData(): Observable<any> {
    return this._http.get<ISite[]>(environment.apiBase + '/sitescontroller/getall?isForTrans=true');
  }


  getAllSitesAssignedToUser(): Observable<any> {
  return this._http.get<ISite[]>(environment.apiBase + '/sitescontroller/getall-assignedsites?isForTrans=true');
}

  getSiteByClientId(clientKey): Observable<any> {
    return this._http.get<ISite[]>(environment.apiBase + `/sitescontroller/getall?clientKey=${clientKey}&isForTrans=true`);
  }

  getSiteByClientIdSitePlanning(clientKey): Observable<any> {
    return this._http.get<ISite[]>(environment.apiBase + `/sitescontroller/getall-siteplanning?clientKey=${clientKey}&isForTrans=true`);
  }

  getSiteByClientIdForCWO(clientKey): Observable<any> {
    return this._http.get<ISite[]>(environment.apiBase + `/sitescontroller/getall?clientKey=${clientKey}&isForTrans=true&isWoDone=true`);
  }

  updateSite(id, payload): Observable<any> {
    return this._http.put(environment.apiBase + `/client/addsite/${id}`, payload);
  }

  createSite(payload): Observable<any> {
    return this._http.post(environment.apiBase + `/sitescontroller/create`, payload)
  }

  deleteSite(id, status): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/sitescontroller/status/${id}?status=${status}`, {})
  }

  // deleteSite(id): Observable<any> {
  //   return this._http.delete<any>(environment.apiBase + '/sitescontroller/delete/' + id)
  // }

  updateSiteByClientId(clientId, siteId, payload): Observable<any> {
    return this._http.put(environment.apiBase + `/sitescontroller/update/client/${clientId}/site/${siteId}`, payload);
  }
  // uom

  getAlluom(): Observable<any> {
    return this._http.get(environment.apiBase + '/uom/all');
  }

  getUOMByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/uom/all/bypagination`, { params });
  }

  getAllActiveuom(): Observable<any> {
    return this._http.get(environment.apiBase + '/uom/all?isForTrans=true');
  }

  addUOM(payload): Observable<any> {
    return this._http.post(environment.apiBase + '/uom/create', payload);
  }

  updateUOM(payload, id): Observable<any> {
    return this._http.put(environment.apiBase + '/uom/update/' + id, payload);
  }

  deleteUOM(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/uom/delete/' + id).pipe(
      catchError(this.handleError)
    );
  }


  // role
  getAllRoles() {
    return this._http.get<any[]>(`${environment.apiBase}/roles/all`);
  }

  getRoleByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/roles/all/bypagination`, { params });
  }

  getAllActiveRoles() {
    return this._http.get<any[]>(`${environment.apiBase}/roles/all?isTransaction=true`);
  }

  addRole(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + `/roles/create?roleName=${payload}`, {})
  }

  updateRole(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/roles/update/${id}?roleName=${payload}`, {})
  }

  activeDeactiveRole(id, status): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/roles/status/${id}?status=${status}`, {})
  }


  // expense
  getAllExpense() {
    return this._http.get<any[]>(`${environment.apiBase}/expense/all`);
  }

  getExpenseByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/expense/all/bypagination`, { params });
  }

  addExpense(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + `/expense/create`, payload)
  }

  updateExpense(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/expense/update/${id}`, payload)
  }

  deleteExpenseType(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/expense/delete/' + id)
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  /**
   * @description This API returns list of work type
   **/
  fetchWorkTypes = (): Observable<any> => {
    return this._http.get(BASE_URL + END_POINTS.WORK_TYPE.FETCH);
  }

  getWorkTypeByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/worktype/all/bypagination`, { params });
  }

  addWorkType(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + `/worktype/create`, payload)
  }

  updateWorkType(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/worktype/update/${id}`, payload)
  }
  deleteWorkType(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/worktype/delete/' + id).pipe(
      catchError(this.handleError)
    );
  }

  //  get boq entry by site id

  getBoqBySiteKey(id): Observable<any> {
    return this._http.get<any>(environment.apiBase + `/boqentry/get?siteKey=${id}`)
  }


  // Gst Master
  getAllGst(): Observable<any> {
    return this._http.get<any>(environment.apiBase + `/gst_master/all`)
  }

  // users
  getAllBanks() {
    return this._http.get<any[]>(`${environment.apiBase}/bank/all`);
  }

  getBankNames() {
    return this._http.get<any[]>(`${environment.apiBase}/bank/names`);
  }

  getBracnchByBankName(bankName: any) {
    return this._http.get<any[]>(`${environment.apiBase}/bank/all?bankName=${bankName}`);
  }

  getBankByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/bank/all/bypagination`, { params });
  }

  addBank(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/bank/create', payload)
  }

  updateBank(payload, id): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/bank/update/' + id, payload)
  }

  activateDeactivatebank(id, status): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/bank/status/${id}?status=${status}`, {})
  }

  deleteBank(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/bank/delete/' + id)
  }

  // make master 

  getAllMakes(): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/makemaster/all')
  }

  getMakeByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/makemaster/all/bypagination`, { params });
  }

  getAllActiveMakes(): Observable<any> {
    return this._http.get<any>(environment.apiBase + `/makemaster/all?isTransaction=true`)
  }

  addMake(payLoad): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/makemaster/create', payLoad)
  }

  updateMake(id, payLoad): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/makemaster/update/${id}`, payLoad)
  }

  updateMakeStatus(id): Observable<any> {
    return this._http.get<any>(environment.apiBase + `/makemaster/make-status?id=${id}`)
  }

  // t&c master 

  createTAC(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/epterms/create', payload)
  }

  updateTAC(id, payLoad): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/epterms/update/${id}`, payLoad)
  }

  getAllTAC(): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/epterms/all')
  }

  getTACByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/epterms/all/bypagination`, { params });
  }

  deleteTAC(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/epterms/delete/' + id)
  }


  // Tower 

  getAllTowers(): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/tower/all')
  }


  addTower(payLoad): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/tower/create', payLoad)
  }

  updateTower(id, payLoad): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/tower/update/${id}`, payLoad)
  }

  // taluka

  getAlltaluka(): Observable<any> {
    return this._http.get(environment.apiBase + '/signup/taluka/all');
  }

  getTalukaByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/signup/taluka/all/bypagination`, { params });
  }

  addTaluka(payLoad): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/signup/taluka/create', payLoad)
  }

  updateTaluka(payload, id): Observable<any> {
    return this._http.put(environment.apiBase + '/signup/taluka/update/' + id, payload);
  }

  importTaluka(file: File): Observable<any> {
    const formData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
    }
    return this._http.post<any>(environment.apiBase + '/signup/taluka/taluka/upload', formData)
  }

  // Payment Terms master 

  createPaymentTerms(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/payment-terms/create', payload)
  }

  updatePaymentTerms(id, payLoad): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/payment-terms/update/${id}`, payLoad)
  }

  getAllPaymentTerms(): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/payment-terms/all')
  }

  getPaymentTermsByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/payment-terms/all/bypagination`, { params });
  }

  deletePaymentTerms(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/payment-terms/delete/' + id)
  }


  //Expense Group
  getExpenseGroupByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/expense-group`, { params });
  }

  addExpenseGroup(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + `/expense-group`, payload)
  }

  updateExpenseGroup(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/expense-group/${id}`, payload)
  }

  deleteExpenseGroup(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/expense-group/' + id)
  }

  getAllExpenseGroup(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/expense-group?export=true&isTransaction=true`);
  }

  getExpenseGroupForSiteBudget(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/expense-group?export=true&isTransaction=true&forSiteBudget=true`);
  }

  getExpenseTypeByExpenseGroup(id): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/expense/all?expenseGroupKey=${id}`);
  }


  //****TDS % ******************* */
  getTDSPer(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/tds`, { params });
  }

  addTDSPer(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/tds', payload)
  }

  updateTDSPer(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/tds/' + id, payload)
  }

  statuschangetds(id, status): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/tds/${id}/status?active=${status}`, {})
  }

  getActiveTDSPer(): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/tds?active=true&export=true`,);
  }

  //Finanacial Year

  getFianYear(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/year`, { params });
  }

  addFinancailYear(payload): Observable<any> {
    return this._http.post(environment.apiBase + '/year', payload);
  }

  updateFinancailYear(id, payload): Observable<any> {
    return this._http.put(environment.apiBase + `/year/${id}`, payload);
  }

  activateYear(id, status): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/year/${id}/status?active=${status}`, {})
  }

  //Email Body

  getEmailPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/email`, { params });
  }

  addEmailMaster(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/email', payload)
  }

  updateEmailMaster(payload, id): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/email/${id}`, payload)
  }

  getEmailbyModule(module): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/email?module=${module}`);
  }


  // Product Type
  getProductTypeByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/product-type/all/bypagination', { params });
  }

  getAllProductType() {
    return this._http.get<any[]>(environment.apiBase + '/product-type/all');
  }

  addProductType(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/product-type/create', payload);
  }

  updateProductType(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/product-type/update/' + id, payload);
  }

  deleteProductType(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/product-type/delete/' + id);
  }

  getSiteStateName(siteKey: number): Observable<string> {
    return this._http.get(`${environment.apiBase}/sitescontroller/site_id/${siteKey}`, {
      responseType: 'text'  // ✅ tell HttpClient to expect plain text
    });
  }

  // --- Tender Estimation Parameter APIs ---

  getTenderEstimationParametersByPageCount(params: any): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/tender-estimation-parameter/page`, params);
  }

  addTenderEstimationParameter(payload: any): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/tender-estimation-parameter`, payload);
  }

  updateTenderEstimationParameter(id: any, payload: any): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/tender-estimation-parameter/${id}`, payload);
  }

  deleteTenderEstimationParameter(id: any): Observable<any> {
    return this._http.delete<any>(`${environment.apiBase}/tender-estimation-parameter/${id}`);
  }
  

  getProjectDates(clientKey: number, siteKey: number): Observable<any> {
    return this._http.get(
      `${environment.apiBase}/site-planning/project-dates`,
      {
        params: {
          clientKey: clientKey.toString(),
          siteKey: siteKey.toString()
        }
      }
    );
  }



getSupplierRates(
  productKey: number,
  supplierKey?: number,
  siteKey?: number,
  searchText?: string,
  page: number = 0,
  size: number = 10
) {

  let params = new HttpParams()
    .set('page', page.toString())
    .set('size', size.toString());

  if (supplierKey != null) {
    params = params.set('supplierKey', supplierKey.toString());
  }

  if (siteKey != null) {
    params = params.set('siteKey', siteKey.toString());
  }

    if (searchText && searchText.trim()) {
    params = params.set('searchText', searchText.trim());
  }

  return this._http.get(
    `${environment.apiBase}/purchaseorder/supplier-rates/${productKey}`,
    { params }
  );
}

getLedger(
  siteKey?: number,
  empKey?: number,
  status?: string,
  fromDate?: string,
  toDate?: string,
  limit: number = 15,
  page: number = 0
) {

  let params = new HttpParams()
    .set('limit', limit.toString())
    .set('page', page.toString());

  if (siteKey != null) {
    params = params.set('siteKey', siteKey.toString());
  }

  if (empKey != null) {
    params = params.set('empKey', empKey.toString());
  }

  if (status && status.trim()) {
    params = params.set('status', status.trim());
  }

  if (fromDate) {
    params = params.set('fromDate', fromDate);
  }

  if (toDate) {
    params = params.set('toDate', toDate);
  }

  // branchKey is no longer sent here — the backend now reads it from the
  // "Branch" HTTP header, same as create/update/get-by-pagination.
  // Make sure whatever adds that header to those other calls (interceptor,
  // manual headers option, etc.) also applies to this request.
  return this._http.get(
    `${environment.apiBase}/expensedata/get-ledger`,
    { params }
  );
}

getExpenseApprovalUsers() {
  return this._http.get<any>(
    `${environment.apiBase}/user/expense-approval-users`
  );
}

getAllWoTypes(page: number = 0, yearKey: number): Observable<any> {
  return this._http.get(`${environment.apiBase}/wo-type/all/bypagination?page=${page}&yearKey=${yearKey}`);
}


getAllBillingMilestones(page: number = 0, yearKey: number): Observable<any> {
  return this._http.get(
    `${environment.apiBase}/billing-milestone/all/bypagination?page=${page}&yearKey=${yearKey}`
  );
}


}
